<template>
  <div class="page-container">
    <div class="main">
      <el-card shadow="never" style="border:none">
        <div slot="header" class="clearfix">
          <el-radio-group size="mini" v-model="value" @input="val => handleInput(val)">
            <el-radio-button label="today">今天</el-radio-button>
            <el-radio-button label="oneWeek">近7天</el-radio-button>
            <el-radio-button label="halfMonth">近15天</el-radio-button>
            <el-radio-button label="oneMonth">近30天</el-radio-button>
          </el-radio-group>
          <el-button style="margin-left:10px" type="primary" plain size="mini" :loading="refreshLoading"
            @click="handleRefreshInfo">刷新</el-button>
        </div>
        <el-card class="cardItem" shadow="never">
          <div slot="header" class="clearfix">
            <span>代收历史统计(万元)</span>
          </div>
          <el-row>
            <el-col :span="12">
              <el-card class="chartCart" shadow="never" v-loading="collectionAmountData.loading">
                <div slot="header" class="clearfix">
                  <span>代收订单金额折线图</span>
                  <el-tag class="tagInfo" size="small" @click="handleScreen(1)">全屏</el-tag>
                </div>
                <div class="chartItem chartItem22">
                  <div v-show="!collectionAmountData.no_more" id="collectionAmount"></div>
                  <div v-show="collectionAmountData.no_more" class="noMore">暂无数据</div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card class="chartCart" shadow="never" v-loading="collectionProfitsData.loading">
                <div slot="header" class="clearfix">
                  <span>代收订单利润折线图</span>
                  <el-tag class="tagInfo" size="small" @click="handleScreen(2)">全屏</el-tag>
                </div>
                <div class="chartItem chartItem22">
                  <div v-show="!collectionProfitsData.no_more" id="collectionProfits"></div>
                  <div v-show="collectionProfitsData.no_more" class="noMore">暂无数据</div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="cardItem" shadow="never">
          <div slot="header" class="clearfix">
            <span>商户订单金额历史统计(万元)</span>
          </div>
          <el-row>
            <el-col :span="12">
              <el-card class="chartCart" shadow="never" v-loading="merchantAmountData.loading">
                <div slot="header" class="clearfix">
                  <span>当前周期前10商户柱状图</span>
                  <el-tag class="tagInfo" size="small" @click="handleScreen(3)">全屏</el-tag>
                </div>
                <div class="chartItem chartItem22">
                  <div v-show="!merchantAmountData.no_more" id="merchantAmount"></div>
                  <div v-show="merchantAmountData.no_more" class="noMore">暂无数据</div>
                </div>
              </el-card>
            </el-col>

            <el-col :span="12">
              <el-card class="chartCart" shadow="never" v-loading="merchantAmountTodayData.loading">
                <div slot="header" class="clearfix">
                  <span>上周期前10商户柱状图</span>
                  <el-tag class="tagInfo" size="small" @click="handleScreen(4)">全屏</el-tag>
                </div>
                <div class="chartItem chartItem22">
                  <div v-show="!merchantAmountTodayData.no_more" id="merchantAmountToday"></div>
                  <div v-show="merchantAmountTodayData.no_more" class="noMore">暂无数据</div>
                </div>
              </el-card>
            </el-col>

          </el-row>
        </el-card>
        <el-card class="cardItem" shadow="never">
          <div slot="header" class="clearfix">
            <span>银行历史统计</span>
          </div>
          <el-row>
            <el-col :span="8">
              <el-card class="chartCart" shadow="never" v-loading="collectionRateData.loading">
                <div slot="header" class="clearfix">
                  <span>银行代收使用率</span>
                  <el-tag class="tagInfo" size="small" @click="handleScreen(5)">全屏</el-tag>
                </div>
                <div class="chartItem">
                  <div v-show="!collectionRateData.no_more" id="collectionRate"></div>
                  <div v-show="collectionRateData.no_more" class="noMore">暂无数据</div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card class="chartCart" shadow="never" v-loading="payusageRateData.loading">
                <div slot="header" class="clearfix">
                  <span>银行代付使用率</span>
                  <el-tag class="tagInfo" size="small" @click="handleScreen(6)">全屏</el-tag>
                </div>
                <div class="chartItem">
                  <div v-show="!payusageRateData.no_more" id="payusageRate"></div>
                  <div v-show="payusageRateData.no_more" class="noMore">暂无数据</div>
                </div>
              </el-card>
            </el-col>
            <el-col :span="8">
              <el-card class="chartCart" shadow="never" v-loading="abnormalPaymentData.loading">
                <div slot="header" class="clearfix">
                  <span>银行代付异常使用率</span>
                  <el-tag class="tagInfo" size="small" @click="handleScreen(7)">全屏</el-tag>
                </div>
                <div class="chartItem">
                  <div v-show="!abnormalPaymentData.no_more" id="abnormalPayment"></div>
                  <div v-show="abnormalPaymentData.no_more" class="noMore">暂无数据</div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-card>
      </el-card>

    </div>
    <el-dialog :title="dialogTitle" width="800px" :visible="dialogShow" @close="closeDialog" @open="openDialog">
      <div v-show="!dialog_no_more" id="detailsChart" v-loading="dialogLoading"></div>
      <div v-show="dialog_no_more" class="noMore">暂无数据</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="closeDialog">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 全屏 -->
    <el-dialog :title="dialogScreenTitle" width="70%" :visible="dialogScreenShow" @close="closeScreenDialog"
      @open="openScreenDialog">
      <div id="screenChart"></div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeScreenDialog">取 消</el-button>
        <el-button type="primary" @click="closeScreenDialog">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'StatisticChart',
  data() {
    return {
      value: 'today',
      collectionAmountData: {
        currentTotal: 0,
        comparisonTotal: 0,
        predictedTotal: 0,
        no_more: false
      },
      collectionProfitsData: {
        currentTotal: 0,
        comparisonTotal: 0,
        predictedTotal: 0,
        no_more: false
      },
      merchantAmountData: {
        no_more: false
      },
      merchantAmountTodayData: {
        no_more: false
      },
      collectionRateData: {
        no_more: false
      },
      payusageRateData: {
        no_more: false
      },
      abnormalPaymentData: {
        no_more: false
      },
      dialogType: 0,
      dialogTitle: '',
      dialogShow: false,
      dialogLoading: false,
      dialog_no_more: false,
      refreshLoading: false,
      dialogScreenTitle: '',
      dialogScreenShow: false,
      screenType: 0
    }
  },
  mounted() {
    let _that = this
    this.collectionAmount = this.$echarts.init(document.getElementById('collectionAmount'))
    this.collectionProfits = this.$echarts.init(document.getElementById('collectionProfits'))
    this.merchantAmount = this.$echarts.init(document.getElementById('merchantAmount'))
    this.merchantAmountToday = this.$echarts.init(document.getElementById('merchantAmountToday'))
    this.collectionRate = this.$echarts.init(document.getElementById('collectionRate'))
    this.payusageRate = this.$echarts.init(document.getElementById('payusageRate'))
    this.abnormalPayment = this.$echarts.init(document.getElementById('abnormalPayment'))
    this.handleCollectionAmount(1)
    this.handleCollectionProfits(1)
    this.handleMerchantAmount(1)
    this.handlemerchantAmountToday(1)
    this.handleCollectionRate(1)
    this.handlePayusageRate(1)
    this.handleAbnormalPayment(1)
    window.addEventListener('resize', this.chartResize);
    this.collectionRate.on('click', function (params) {
      _that.collectionRateData.index = params.dataIndex
      _that.dialogType = 3
      _that.dialogShow = true
    });
    this.payusageRate.on('click', function (params) {
      console.log(params)
      _that.payusageRateData.index = params.dataIndex
      _that.dialogType = 4
      _that.dialogShow = true
    });
    this.abnormalPayment.on('click', function (params) {
      console.log(params)
      _that.abnormalPaymentData.index = params.dataIndex
      _that.dialogType = 5
      _that.dialogShow = true
    });
    this.merchantAmount.on('click', function (params) {
      _that.merchantAmountData.index = params.dataIndex
      _that.dialogType = 1
      _that.dialogShow = true
    });
    this.merchantAmountToday.on('click', function (params) {
      _that.merchantAmountTodayData.index = params.dataIndex
      _that.dialogType = 2
      _that.dialogShow = true
    });
  },
  created() {

  },
  methods: {
    handleScreen(type) {
      this.screenType = type
      switch (type) {
        case 1:
          this.handleCollectionAmount(2);
          this.dialogScreenTitle = '代收订单金额折线图'
          break;
        case 2:
          this.dialogScreenTitle = '代收订单利润折线图'
          break;
        case 3:
          this.dialogScreenTitle = '当前周期前10商户柱状图'
          break;
        case 4:
          this.dialogScreenTitle = '上周期前10商户柱状图'
          break;
        case 5:
          this.dialogScreenTitle = '银行代收使用率'
          break;
        case 6:
          this.dialogScreenTitle = '银行代付使用率'
          break;
        case 7:
          this.dialogScreenTitle = '银行代付异常使用率'
          break;
      }
      this.dialogScreenShow = true
    },
    openScreenDialog() {
      let _that = this;
      this.$nextTick(() => {
        _that.screenChart = _that.$echarts.init(document.getElementById('screenChart'))
        switch (_that.screenType) {
          case 1:
            _that.handleCollectionAmount(2)
            break;
          case 2:
            _that.handleCollectionProfits(2)
            break;
          case 3:
            _that.handleMerchantAmount(2)
            break;
          case 4:
            _that.handlemerchantAmountToday(2)
            break;
          case 5:
            _that.handleCollectionRate(2)
            break;
          case 6:
            _that.handlePayusageRate(2)
            break;
          case 7:
            _that.handleAbnormalPayment(2)
            break;
        }
      })
    },
    closeScreenDialog() {
      this.dialogScreenShow = false
    },
    openDialog() {
      let _that = this
      this.dialogLoading = true
      this.dialog_no_more = false
      this.$nextTick(() => {
        _that.detailsChart = _that.$echarts.init(document.getElementById('detailsChart'))
        let params = {}
        switch (_that.dialogType) {
          case 1:
            _that.dialogTitle = '当前周期前10商户柱状图'
            params = {
              appId: _that.merchantAmountData.merchantId[_that.merchantAmountData.index],
              statisticsSelectType: 'merchantPayInAmount',
              statisticsTimeType: _that.value
            }
            _that.handleMerchantDetail(params, _that.merchantAmountData.x[_that.merchantAmountData.index], 1)
            break;
          case 2:
            _that.dialogTitle = '上周期前10商户柱状图'
            params = {
              appId: _that.merchantAmountTodayData.merchantId[_that.merchantAmountTodayData.index],
              statisticsSelectType: 'merchantPayInAmountToday',
              statisticsTimeType: _that.value
            }
            _that.handleMerchantDetail(params, _that.merchantAmountTodayData.x[_that.merchantAmountTodayData.index], 1)
            break;
          case 3:
            _that.dialogTitle = '银行代收使用率详情'
            params = {
              bankCode: _that.collectionRateData.bankCode[_that.collectionRateData.index],
              statisticsSelectType: 'payInBankUsageRate',
              statisticsTimeType: _that.value
            }
            _that.handleDetails(params, _that.collectionRateData.x[_that.collectionRateData.index])
            break;
          case 4:
            _that.dialogTitle = '银行代付使用率详情'
            params = {
              bankCode: _that.payusageRateData.bankCode[_that.payusageRateData.index],
              statisticsSelectType: 'payOutBankUsageRate',
              statisticsTimeType: _that.value
            }
            _that.handleDetails(params, _that.payusageRateData.x[_that.payusageRateData.index])
            break;
          case 5:
            _that.dialogTitle = '银行代付异常使用率详情'
            params = {
              bankCode: _that.abnormalPaymentData.bankCode[_that.abnormalPaymentData.index],
              statisticsSelectType: 'payOutErrorBankUsageRate',
              statisticsTimeType: _that.value
            }
            _that.handleDetails(params, _that.abnormalPaymentData.x[_that.abnormalPaymentData.index])
            break;
        }

      })
    },
    handleMerchantDetail(params, text, type) {
      this.axios.get("/statistics/merchant/Detail", { params: params }).then(res => {
        if (res.code == 200) {
          this.dialogLoading = false
          let x1 = []
          let x2 = []
          let data1 = []
          let data2 = []
          res.data.currentList.map(item => {
            x1.push(item.timeFormat)
            if (type == 1) {
              data1.push(item.amountCount)
            } else {
              data1.push(item.orderCount)
            }
          })
          if (res.data.comparisonList) {
            res.data.comparisonList.map(item => {
              x2.push(item.timeFormat)
              if (type == 1) {
                data2.push(item.amountCount)
              } else {
                data2.push(item.orderCount)
              }

            })
          }
          if (x1.length == 0 && x2.length == 0) {
            this.dialog_no_more = true
          }
          let option = {
            legend: {
              data: [`上周期数据: ${res.data.comparisonTotal ? res.data.comparisonTotal : 0}`, `当前数据: ${res.data.currentTotal}`]
            },
            title: {
              text: text,
              top: 20,
              left: 'center'
            },
            tooltip: {
              trigger: 'none',
              axisPointer: {
                type: 'cross'
              }
            },
            grid: {
              top: 70,
              bottom: 50
            },
            xAxis: [
              {
                type: 'category',
                axisTick: {
                  alignWithLabel: true
                },
                axisLine: {
                  onZero: false,
                },
                axisPointer: {
                  label: {
                    formatter: function (params) {
                      console.log(params)
                      let currentIndex = 0;
                      let total = 0;
                      if (params.seriesData.length) {
                        currentIndex = params.seriesData[0].dataIndex
                        data1.map((item, index) => {
                          if (index <= currentIndex) {
                            total += parseFloat(item)
                          }
                        })
                      }
                      return (
                        params.value + (params.seriesData.length ?
                          '\n' + + params.seriesData[0].data : '') + (total ? '\n' + total.toFixed(3) : '')
                      );
                    }
                  }
                },
                data: x1
              },
              {
                type: 'category',
                axisTick: {
                  alignWithLabel: true
                },
                axisLine: {
                  onZero: false,
                },
                axisPointer: {
                  label: {
                    formatter: function (params) {
                      console.log(params)
                      let currentIndex = 0;
                      let total = 0;
                      if (params.seriesData.length) {
                        currentIndex = params.seriesData[0].dataIndex
                        data2.map((item, index) => {
                          if (index <= currentIndex) {
                            total += parseFloat(item)
                          }
                        })
                      }
                      return (
                        params.value + (params.seriesData.length ?
                          '\n' + + params.seriesData[0].data : '') + (total ? '\n' + total.toFixed(3) : '')
                      );
                    }
                  }
                },
                data: x2
              }
            ],
            yAxis: [
              {
                type: 'value',
                boundaryGap: ['15%', '15%']
              }
            ],
            series: [
              {
                type: 'line',
                name: `当前数据: ${res.data.currentTotal}`,
                data: data1,
                lineStyle: {
                  color: '#4C88F5'
                },
                itemStyle: {
                  color: '#4C88F5'
                }
              },
              {
                type: 'line',
                xAxisIndex: 1,
                name: `上周期数据: ${res.data.comparisonTotal ? res.data.comparisonTotal : 0}`,
                data: data2,
                lineStyle: {
                  color: '#2E4555'
                },
                itemStyle: {
                  color: '#2E4555'
                }
              },
            ]
          }
          this.detailsChart.setOption(option)
        } else {
          this.dialogLoading = false
          this.dialog_no_more = true
        }
      })
    },
    handleDetails(params, text) {
      this.axios.get("/statistics/bankUsageRate/Detail", { params: params }).then(res => {
        if (res.code === 200) {
          console.log(res.data)
          this.dialogLoading = false
          let x1 = []
          let x2 = []
          let data1 = []
          let data2 = []
          res.data.currentList.map(item => {
            x1.push(item.timeFormat)
            data1.push(item.usageRate)
          })
          if (res.data.comparisonList) {
            res.data.comparisonList.map(item => {
              x2.push(item.timeFormat)
              data2.push(item.usageRate)
            })
          }
          if (x1.length == 0 && x2.length == 0) {
            this.dialog_no_more = true
          }
          let option = {
            title: {
              text: text,
              top: 20,
              left: 'center'
            },
            tooltip: {
              trigger: 'none',
              axisPointer: {
                type: 'cross'
              }
            },
            grid: {
              top: 70,
              bottom: 50
            },
            xAxis: [
              {
                type: 'category',
                axisTick: {
                  alignWithLabel: true
                },
                axisLine: {
                  onZero: false,
                  lineStyle: {
                    color: '#4C88F5',
                  },
                },
                axisPointer: {
                  label: {
                    formatter: function (params) {
                      console.log(params)
                      let currentIndex = 0;
                      let total = 0;
                      if (params.seriesData.length) {
                        currentIndex = params.seriesData[0].dataIndex
                        data1.map((item, index) => {
                          if (index <= currentIndex) {
                            total += parseFloat(item)
                          }
                        })
                      }
                      return (
                        params.value + (params.seriesData.length ?
                          '\n' + + params.seriesData[0].data : '') + (total ? '\n' + total.toFixed(3) : '')
                      );
                    }
                  }
                },
                data: x1
              },
              {
                type: 'category',
                axisTick: {
                  alignWithLabel: true
                },
                axisLine: {
                  onZero: false,
                  lineStyle: {
                    color: '#2E4555',
                  },
                },
                axisPointer: {
                  label: {
                    formatter: function (params) {
                      console.log(params)
                      let currentIndex = 0;
                      let total = 0;
                      if (params.seriesData.length) {
                        currentIndex = params.seriesData[0].dataIndex
                        data2.map((item, index) => {
                          if (index <= currentIndex) {
                            total += parseFloat(item)
                          }
                        })
                      }
                      return (
                        params.value + (params.seriesData.length ?
                          '\n' + + params.seriesData[0].data : '') + (total ? '\n' + total.toFixed(3) : '')
                      );
                    }
                  }
                },
                data: x2
              }
            ],
            yAxis: [
              {
                type: 'value',
                boundaryGap: ['15%', '15%']
              }
            ],
            series: [
              {
                type: 'line',
                data: data1,
                lineStyle: {
                  color: '#4C88F5'
                },
                itemStyle: {
                  color: '#4C88F5'
                }
              },
              {
                type: 'line',
                xAxisIndex: 1,
                data: data2,
                lineStyle: {
                  color: '#2E4555'
                },
                itemStyle: {
                  color: '#2E4555'
                }
              },

            ]
          }
          this.detailsChart.setOption(option)
        } else {
          this.dialogLoading = false
          this.dialog_no_more = true
        }
      })
    },
    closeDialog() {
      this.dialogShow = false
    },
    handleRefreshInfo() {
      this.refreshLoading = true
      this.handleInput()
    },
    handleInput(val) {
      this.handleCollectionAmount(1)
      this.handleCollectionProfits(1)
      this.handleMerchantAmount(1)
      this.handlemerchantAmountToday(1)
      this.handleCollectionRate(1)
      this.handlePayusageRate(1)
      this.handleAbnormalPayment(1)
    },
    handleResult(data, type) {
      let x1 = []
      let x2 = []
      let data1 = []
      let data1_1 = []
      let data2 = []
      let index1 = 0
      data.currentList.map((item, index) => {
        x1.push(item.timeFormat)
        if ((index + 1) < data.currentList.length && data.currentList[index + 1].predictedData) {
          index1++
        }
        switch (type) {
          case 1:
            if (item.predictedData) {
              data1_1.push(item.orderCount)
              if (index1 == 1) {
                data1.push(item.orderCount)
              } else {
                data1.push('-')
              }
            } else {
              data1.push(item.orderCount)
              if (index1 == 1) {
                data1_1.push(item.orderCount)
              } else {
                data1_1.push('-')
              }
            }
            break;
          case 2:
            if (item.predictedData) {
              data1_1.push(parseFloat(item.amountCount).toFixed(2))
              if (index1 == 1) {
                data1.push(parseFloat(item.amountCount).toFixed(2))
              } else {
                data1.push('-')
              }
            } else {
              data1.push(parseFloat(item.amountCount).toFixed(2))
              if (index1 == 1) {
                data1_1.push(parseFloat(item.amountCount).toFixed(2))
              } else {
                data1_1.push('-')
              }
            }
            break;
          case 3:
            if (item.predictedData) {
              data1_1.push(item.profits)
              if (index1 == 1) {
                data1.push(item.profits)
              } else {
                data1.push('-')
              }
            } else {
              data1.push(item.profits)
              if (index1 == 1) {
                data1_1.push(item.profits)
              } else {
                data1_1.push('-')
              }
            }
            break;
        }
        if (type == 1) {

        } else {

        }
      })
      if (data.comparisonList) {
        data.comparisonList.map(item => {
          x2.push(item.timeFormat)
          switch (type) {
            case 1:
              data2.push(item.orderCount)
              break;
            case 2:
              data2.push(parseFloat(item.amountCount).toFixed(2))
              break;
            case 3:
              data2.push(item.profits)
              break;
          }
        })
      }
      console.log({
        x1: x1,
        x2: x2,
        data1: data1,
        data1_1: data1_1,
        data2: data2,
        currentTotal: parseFloat(data.currentTotal).toFixed(2),
        comparisonTotal: data.comparisonTotal ? parseFloat(data.comparisonTotal).toFixed(2) : '0.00'
      })
      return {
        x1: x1,
        x2: x2,
        data1: data1,
        data1_1: data1_1,
        data2: data2,
        currentTotal: parseFloat(data.currentTotal).toFixed(2),
        predictedTotal: data.predictedTotal ? parseFloat(data.predictedTotal).toFixed(2) : '0.00',
        comparisonTotal: data.comparisonTotal ? parseFloat(data.comparisonTotal).toFixed(2) : '0.00'
      }
    },
    handleResultBarMerchant(data) {
      let x = []
      let data1 = []
      let data2 = []
      let merchantId = []
      data.map(item => {
        x.push(item.merchantName)
        data1.push(item.currentTotal == 'null' || !item.currentTotal ? 0 : item.currentTotal)
        data2.push(item.comparisonTotal == 'null' || !item.comparisonTotal ? 0 : item.comparisonTotal)
        merchantId.push(item.merchantId)
      })
      return {
        x: x,
        data1: data1,
        data2: data2,
        merchantId: merchantId
      }
    },
    handleResultBar(data) {
      let x = []
      let data1 = []
      let data2 = []
      let bankCode = []
      data.map(item => {
        x.push(item.bankName)
        data1.push(item.currentBankUsage)
        data2.push(item.comparisonBankUsage == 'null' || !item.comparisonBankUsage ? 0 : item.comparisonBankUsage)
        bankCode.push(item.bankCode)
      })
      return {
        x: x,
        data1: data1,
        data2: data2,
        bankCode: bankCode
      }
    },
    handleCollectionAmount(type) {
      let _that = this;
      let params = {
        statisticsSelectType: 'payInAmount',
        statisticsTimeType: this.value
      }
      this.collectionAmountData.loading = true
      this.axios.get("/statistics/order", { params: params }).then(res => {
        if (res.code === 200) {
          console.log(res.data)
          let result = this.handleResult(res.data, 2)
          this.collectionAmountData = result
          if (result.x1.length == 0 && result.x2.length == 0) {
            this.collectionAmountData.no_more = true
          }
          let option = {
            legend: {
              data: [`上周期数据: ${this.collectionAmountData.comparisonTotal}`, `当前数据: ${this.collectionAmountData.currentTotal}`, `推测数据: ${this.collectionAmountData.predictedTotal}`]
            },
            tooltip: {
              trigger: 'none',
              axisPointer: {
                type: 'cross'
              }
            },
            grid: {
              top: 50,
              bottom: 20,
              left: 100,
              right: '4%',
            },
            xAxis: [
              {
                type: 'category',
                boundaryGap: [0, '25%'],
                axisTick: {
                  alignWithLabel: true
                },
                axisLine: {
                  onZero: false,
                  lineStyle: {
                    color: '#4C88F5',
                  },
                },
                axisPointer: {
                  label: {
                    lineHeight: 20,

                    formatter: function (params) {
                      console.log(params)
                      let currentIndex = 0;
                      let total = 0;
                      if (params.seriesData.length) {
                        currentIndex = params.seriesData[0].dataIndex
                        _that.collectionAmountData.data1.map((item, index) => {
                          if (index <= currentIndex) {
                            if (item == '-') {
                              total += parseFloat(_that.collectionAmountData.data1_1[index])
                            } else {
                              total += parseFloat(item)
                            }

                          }
                        })
                      }
                      return (
                        params.value + (params.seriesData.length ? '\n' + (params.seriesData[0].data == '-' ? (params.seriesData.length == 1 ? params.seriesData[0].data : params.seriesData[1].data) : params.seriesData[0].data) : '') + (total ? ' \n' + total.toFixed(3) : '')
                      );
                    }
                  }
                },
                data: result.x1
              },
              {
                type: 'category',
                axisTick: {
                  alignWithLabel: true
                },
                axisLine: {
                  onZero: false,
                  lineStyle: {
                    color: '#2E4555',
                  },

                },
                axisPointer: {
                  label: {
                    formatter: function (params) {
                      console.log(params)
                      let currentIndex = 0;
                      let total = 0;
                      if (params.seriesData.length) {
                        currentIndex = params.seriesData[0].dataIndex
                        _that.collectionAmountData.data2.map((item, index) => {
                          if (index <= currentIndex) {
                            total += parseFloat(item)
                          }
                        })
                      }
                      return (
                        params.value + (params.seriesData.length ?
                          '\n' + + params.seriesData[0].data : '') + (total ? '\n' + total.toFixed(3) : '')
                      );
                    }
                  }
                },
                data: result.x2
              }
            ],
            yAxis: [
              {
                type: 'value',
                scale: true,
                boundaryGap: [0, '15%']
              }
            ],
            dataZoom: [
              {
                type: 'inside',
                filterMode: 'filter',
                start: 0,
                end: 100,
                xAxisIndex: 0
              },
              {
                type: 'inside',
                filterMode: 'filter',
                start: 0,
                end: 100,
                xAxisIndex: 1
              }
            ],
            series: [
              {
                type: 'line',
                name: `当前数据: ${this.collectionAmountData.currentTotal}`,

                data: result.data1,
                lineStyle: {
                  color: '#4C88F5'
                },
                itemStyle: {
                  color: '#4C88F5'
                }
              },
              {
                type: 'line',
                name: `上周期数据: ${this.collectionAmountData.comparisonTotal}`,
                xAxisIndex: 1,

                data: result.data2,
                lineStyle: {
                  color: '#2E4555'
                },
                itemStyle: {
                  color: '#2E4555'
                }
              },
              {
                type: 'line',
                name: `推测数据: ${this.collectionAmountData.predictedTotal}`,
                data: result.data1_1,
                lineStyle: {
                  width: 2,
                  type: 'dotted',
                  color: '#91cc75',
                },
                itemStyle: {
                  color: '#91cc75'
                }
              }
            ]
          }
          if (type == 1) {
            this.collectionAmount.setOption(option)
          } else {
            this.screenChart.setOption(option)
          }

        } else {
          this.collectionAmountData.no_more = true
          this.collectionAmountData.loading = false
        }
      })
    },
    handleCollectionProfits(type) {
      let _that = this;
      let params = {
        statisticsSelectType: 'payInProfits',
        statisticsTimeType: this.value
      }
      this.collectionProfitsData.loading = true
      this.axios.get("/statistics/order", { params: params }).then(res => {
        if (res.code === 200) {
          console.log(res.data)
          let result = this.handleResult(res.data, 3)
          this.collectionProfitsData = result
          if (result.x1.length == 0 && result.x2.length == 0) {
            this.collectionProfitsData.no_more = true
          }

          let option = {
            legend: {
              data: [`上周期数据: ${this.collectionProfitsData.comparisonTotal}`, `当前数据: ${this.collectionProfitsData.currentTotal}`, `推测数据: ${this.collectionProfitsData.predictedTotal}`]
            },
            tooltip: {
              trigger: 'none',
              axisPointer: {
                type: 'cross'
              }
            },
            grid: {
              top: 50,
              bottom: 20,
              left: 100,
              right: '4%',
            },
            xAxis: [
              {
                type: 'category',
                boundaryGap: [0, '25%'],
                axisTick: {
                  alignWithLabel: true
                },
                axisLine: {
                  onZero: false,
                  lineStyle: {
                    color: '#4C88F5',
                  },
                },
                axisPointer: {
                  label: {
                    formatter: function (params) {
                      console.log(params)
                      let currentIndex = 0;
                      let total = 0;
                      if (params.seriesData.length) {
                        currentIndex = params.seriesData[0].dataIndex
                        _that.collectionProfitsData.data1.map((item, index) => {
                          if (index <= currentIndex) {
                            if (item == '-') {
                              total += parseFloat(_that.collectionProfitsData.data1_1[index])
                            } else {
                              total += parseFloat(item)
                            }

                          }
                        })
                      }
                      return (
                        params.value + (params.seriesData.length ? '\n' + (params.seriesData[0].data == '-' ? (params.seriesData.length == 1 ? params.seriesData[0].data : params.seriesData[1].data) : params.seriesData[0].data) : '') + (total ? ' \n' + total.toFixed(3) : '')
                      );
                    }
                  }
                },
                data: result.x1
              },
              {
                type: 'category',
                axisTick: {
                  alignWithLabel: true
                },
                axisLine: {
                  onZero: false,
                  lineStyle: {
                    color: '#2E4555',
                  },
                },
                axisPointer: {
                  label: {
                    formatter: function (params) {
                      console.log(params)
                      let currentIndex = 0;
                      let total = 0;
                      if (params.seriesData.length) {
                        currentIndex = params.seriesData[0].dataIndex
                        _that.collectionProfitsData.data2.map((item, index) => {
                          if (index <= currentIndex) {
                            total += parseFloat(item)
                          }
                        })
                      }
                      return (
                        params.value + (params.seriesData.length ?
                          '\n' + + params.seriesData[0].data : '') + (total ? '\n' + total.toFixed(3) : '')
                      );
                    }
                  }
                },
                data: result.x2
              }
            ],
            yAxis: [
              {
                type: 'value',
                scale: true,
                boundaryGap: [0, '15%']
              }
            ],
            dataZoom: [
              {
                type: 'inside',
                filterMode: 'filter',
                start: 0,
                end: 100,
                xAxisIndex: 0
              },
              {
                type: 'inside',
                filterMode: 'filter',
                start: 0,
                end: 100,
                xAxisIndex: 1
              }
            ],
            series: [
              {
                type: 'line',
                name: `当前数据: ${this.collectionProfitsData.currentTotal}`,

                data: result.data1,
                lineStyle: {
                  color: '#4C88F5'
                },
                itemStyle: {
                  color: '#4C88F5'
                }
              },
              {
                type: 'line',
                name: `上周期数据: ${this.collectionProfitsData.comparisonTotal}`,
                xAxisIndex: 1,

                data: result.data2,
                lineStyle: {
                  color: '#2E4555'
                },
                itemStyle: {
                  color: '#2E4555'
                }
              },
              {
                type: 'line',
                name: `推测数据: ${this.collectionProfitsData.predictedTotal}`,
                data: result.data1_1,
                lineStyle: {
                  width: 2,
                  type: 'dotted',
                  color: '#91cc75',
                },
                itemStyle: {
                  color: '#91cc75'
                }
              }
            ]
          }
          if (type == 1) {
            this.collectionProfits.setOption(option)
          } else {
            this.screenChart.setOption(option)
          }

        } else {
          this.collectionProfitsData.no_more = true
          this.collectionProfitsData.loading = false
        }
      })
    },
    handleMerchantAmount(type) {
      let params = {
        statisticsSelectType: 'merchantPayInAmount',
        statisticsTimeType: this.value
      }
      this.merchantAmountData.loading = true
      this.axios.get("/statistics/merchant", { params: params }).then(res => {
        if (res.code === 200) {
          let result = this.handleResultBarMerchant(res.data)
          this.merchantAmountData = result
          if (result.x.length == 0) {
            this.merchantAmountData.no_more = true
          }
          let option = {
            legend: {
              data: [`上周期数据`, `当前数据`]
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true,
              top: 24,
            },
            xAxis: {
              type: 'value',
              boundaryGap: [0, 0.01]
            },
            yAxis: {
              type: 'category',
              data: result.x
            },
            dataZoom: {
              type: 'inside',
              yAxisIndex: 0,
              start: 0,
              end: 100,
            },
            series: [
              {
                type: 'bar',
                data: result.data2,
                name: '上周期数据',
                lineStyle: {
                  color: '#2E4555'
                },
                itemStyle: {
                  color: '#2E4555'
                },
                label: {
                  show: true,
                  position: 'right'
                },
              },
              {
                type: 'bar',
                data: result.data1,
                name: '当前数据',
                lineStyle: {
                  color: '#4C88F5'
                },
                itemStyle: {
                  color: '#4C88F5'
                },
                label: {
                  show: true,
                  position: 'right'
                },
              },
            ]
          };
          if (type == 1) {
            this.merchantAmount.setOption(option)
          } else {
            this.screenChart.setOption(option)
          }
        } else {
          this.merchantAmountData.no_more = true
          this.merchantAmountData.loading = false
        }
      })

    },
    handlemerchantAmountToday(type) {
      let params = {
        statisticsSelectType: 'merchantPayInAmountToday',
        statisticsTimeType: this.value
      }
      this.merchantAmountTodayData.loading = true
      this.axios.get("/statistics/merchant", { params: params }).then(res => {
        if (res.code === 200) {
          let result = this.handleResultBarMerchant(res.data)
          this.merchantAmountTodayData = result
          if (result.x.length == 0) {
            this.merchantAmountTodayData.no_more = true
          }
          let option = {
            legend: {
              data: [`上周期数据`, `当前数据`]
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true,
              top: 24,
            },
            xAxis: {
              type: 'value',
              boundaryGap: [0, 0.01]
            },
            yAxis: {
              type: 'category',
              data: result.x
            },
            dataZoom: {
              type: 'inside',
              yAxisIndex: 0,
              start: 0,
              end: 100,
            },
            series: [
              {
                type: 'bar',
                data: result.data1,
                name: '上周期数据',
                lineStyle: {
                  color: '#2E4555'
                },
                itemStyle: {
                  color: '#2E4555'
                },
                label: {
                  show: true,
                  position: 'right'
                },
              },
              {
                type: 'bar',
                data: result.data2,
                name: '当前数据',
                lineStyle: {
                  color: '#4C88F5'
                },
                itemStyle: {
                  color: '#4C88F5'
                },
                label: {
                  show: true,
                  position: 'right'
                },
              },
            ]
          };
          if (type == 1) {
            this.merchantAmountToday.setOption(option)
          } else {
            this.screenChart.setOption(option)
          }
        } else {
          this.merchantAmountTodayData.no_more = true
          this.merchantAmountTodayData.loading = false
        }
      })

    },
    handleCollectionRate(type) {
      let params = {
        statisticsSelectType: 'payInBankUsageRate',
        statisticsTimeType: this.value
      }
      this.collectionRateData.loading = true
      this.axios.get("/statistics/bankUsageRate", { params: params }).then(res => {
        if (res.code === 200) {
          console.log(res.data)
          let result = this.handleResultBar(res.data)
          this.collectionRateData = result
          if (result.x.length == 0) {
            this.collectionRateData.no_more = true
          }
          let option = {
            legend: {
              data: [`上周期数据`, `当前数据`]
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              top: 24,
              containLabel: true
            },
            xAxis: {
              type: 'value',
              boundaryGap: [0, 0.01]
            },
            yAxis: {
              type: 'category',
              data: result.x
            },
            dataZoom: {
              type: 'inside',
              yAxisIndex: 0,
              start: 0,
              end: 100,
            },
            series: [
              {
                type: 'bar',
                data: result.data2,
                name: '上周期数据',
                lineStyle: {
                  color: '#2E4555'
                },
                itemStyle: {
                  color: '#2E4555'
                },
                label: {
                  show: true,
                  position: 'right'
                },
              },
              {
                type: 'bar',
                data: result.data1,
                name: '当前数据',
                lineStyle: {
                  color: '#4C88F5'
                },
                itemStyle: {
                  color: '#4C88F5'
                },
                label: {
                  show: true,
                  position: 'right'
                },
              },

            ]
          };
          if (type == 1) {
            this.collectionRate.setOption(option)
          } else {
            this.screenChart.setOption(option)
          }
        } else {
          this.collectionRateData.no_more = true
          this.collectionRateData.loading = false
        }
      })

    },
    handlePayusageRate(type) {
      let params = {
        statisticsSelectType: 'payOutBankUsageRate',
        statisticsTimeType: this.value
      }
      this.payusageRateData.loading = true
      this.axios.get("/statistics/bankUsageRate", { params: params }).then(res => {
        if (res.code === 200) {
          console.log(res.data)
          let result = this.handleResultBar(res.data)
          this.payusageRateData = result
          if (result.x.length == 0) {
            this.payusageRateData.no_more = true
          }
          let option = {
            legend: {
              data: [, `上周期数据`, `当前数据`]
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              top: 24,
              containLabel: true
            },
            xAxis: {
              type: 'value',
              boundaryGap: [0, 0.01]
            },
            yAxis: {
              type: 'category',
              data: result.x
            },
            dataZoom: {
              type: 'inside',
              yAxisIndex: 0,
              start: 0,
              end: 100,
            },
            series: [
              {
                type: 'bar',
                data: result.data2,
                name: '上周期数据',
                lineStyle: {
                  color: '#2E4555'
                },
                itemStyle: {
                  color: '#2E4555'
                },
                label: {
                  show: true,
                  position: 'right'
                },
              },
              {
                type: 'bar',
                data: result.data1,
                name: '当前数据',
                lineStyle: {
                  color: '#4C88F5'
                },
                itemStyle: {
                  color: '#4C88F5'
                },
                label: {
                  show: true,
                  position: 'right'
                },
              },

            ]
          };
          if (type == 1) {
            this.payusageRate.setOption(option)
          } else {
            this.screenChart.setOption(option)
          }
        } else {
          this.payusageRateData.no_more = true
          this.payusageRateData.loading = false
        }
      })
    },
    handleAbnormalPayment(type) {
      let params = {
        statisticsSelectType: 'payOutErrorBankUsageRate',
        statisticsTimeType: this.value
      }
      this.abnormalPaymentData.loading = true
      this.axios.get("/statistics/bankUsageRate", { params: params }).then(res => {
        if (res.code === 200) {
          console.log(res.data)
          let result = this.handleResultBar(res.data)
          this.abnormalPaymentData = result
          if (result.x.length == 0) {
            this.abnormalPaymentData.no_more = true
          }
          let option = {
            legend: {
              data: [`上周期数据`, `当前数据`]
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              top: 24,
              containLabel: true
            },
            xAxis: {
              type: 'value',
              boundaryGap: [0, 0.01]
            },
            yAxis: {
              type: 'category',
              data: result.x
            },
            dataZoom: {
              type: 'inside',
              yAxisIndex: 0,
              start: 0,
              end: 100,
            },
            series: [
              {
                type: 'bar',
                data: result.data2,
                name: '上周期数据',
                lineStyle: {
                  color: '#2E4555'
                },
                itemStyle: {
                  color: '#2E4555'
                },
                label: {
                  show: true,
                  position: 'right'
                },
              },
              {
                type: 'bar',
                data: result.data1,
                name: '当前数据',
                lineStyle: {
                  color: '#4C88F5'
                },
                itemStyle: {
                  color: '#4C88F5'
                },
                label: {
                  show: true,
                  position: 'right'
                },
              },
            ]
          };
          if (type == 1) {
            this.abnormalPayment.setOption(option)
          } else {
            this.screenChart.setOption(option)
          }
        } else {
          this.abnormalPaymentData.no_more = true
          this.abnormalPaymentData.loading = false
        }
      })
    },
    chartResize() {
      if (this.dialogScreenShow) {
        this.screenChart.resize();
      }
      let eleArr = [this.collectionAmount, this.collectionProfits, this.merchantAmount, this.merchantAmountToday, this.collectionRate, this.payusageRate, this.abnormalPayment];
      for (let i = 0; i < eleArr.length; i++) {
        // 此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
        setTimeout(function () {
          eleArr[i].resize();
        }, 200);
      }
    }
  }
}
</script>
<style>
canvas {
  background-color: #fff;
}
</style>
<style lang="scss" scoped>
.tagInfo {
  cursor: pointer;
  margin-left: 10px;
}

::v-deep .el-card__header {
  padding: 4px 20px;
  font-size: 15px;
}

::v-deep .el-card__body {
  padding: 6px;
}

.noMore {
  height: 30vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #909399;
}

.page-container {
  border-left: 1px solid #dce4ea;
}

.cardItem {
  margin-bottom: 6px;

  .chartItem {
    height: 30vh;
  }

  .chartItem22 {
    height: 34vh;
  }

  #collectionAmount,
  #collectionProfits,
  #merchantAmount,
  #merchantAmountToday,
  #merchantOrder,
  #collectionRate,
  #payusageRate,
  #abnormalPayment {
    width: 100%;
    height: 100%;
  }
}

::v-deep .chartCart {
  border: none;
  position: relative;

  .el-card__header {
    font-weight: bold;
    padding: 0;
    border: none;
    text-align: center;
    padding-bottom: 4px;
    font-size: 15px;

    .total {
      font-weight: normal;
      color: #F56C6C;
      margin-left: 16px;
    }
  }

  .el-card__body {
    padding: 0;
  }

}

#detailsChart {
  width: 100%;
  height: 400px;
}

#screenChart {
  width: 100%;
  height: calc(100vh - 400px);
}
</style>